import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import BarChartIcon from "@mui/icons-material/BarChart";
import BuildIcon from "@mui/icons-material/Build";
import BusinessIcon from "@mui/icons-material/Business";
import CellTowerIcon from "@mui/icons-material/CellTower";
import ChecklistIcon from "@mui/icons-material/Checklist";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DescriptionIcon from "@mui/icons-material/Description";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import FeedbackIcon from "@mui/icons-material/Feedback";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import GavelIcon from "@mui/icons-material/Gavel";
import HandshakeIcon from "@mui/icons-material/Handshake";
import HandymanIcon from "@mui/icons-material/Handyman";
import HistoryIcon from "@mui/icons-material/History";
import InventoryIcon from "@mui/icons-material/Inventory";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import MapIcon from "@mui/icons-material/Map";
import MessageIcon from "@mui/icons-material/Message";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import NotesIcon from "@mui/icons-material/Notes";
import NotificationsIcon from "@mui/icons-material/Notifications";
import PeopleIcon from "@mui/icons-material/People";
import PersonIcon from "@mui/icons-material/Person";
import PublicIcon from "@mui/icons-material/Public";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import RouteIcon from "@mui/icons-material/Route";
import RuleIcon from "@mui/icons-material/Rule";
import ScheduleIcon from "@mui/icons-material/Schedule";
import SecurityIcon from "@mui/icons-material/Security";
import SettingsIcon from "@mui/icons-material/Settings";
import ShieldIcon from "@mui/icons-material/Shield";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import StorageIcon from "@mui/icons-material/Storage";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import TimerOffIcon from "@mui/icons-material/TimerOff";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

/** @type {Record<string, import("@mui/material").SvgIconComponent>} */
const NAV_ICONS = {
  AccountBalance: AccountBalanceIcon,
  AccountBalanceWallet: AccountBalanceWalletIcon,
  Assessment: AssessmentIcon,
  Assignment: AssignmentIcon,
  AutoAwesome: AutoAwesomeIcon,
  BarChart: BarChartIcon,
  Build: BuildIcon,
  Business: BusinessIcon,
  CellTower: CellTowerIcon,
  Checklist: ChecklistIcon,
  Dashboard: DashboardIcon,
  Description: DescriptionIcon,
  DirectionsCar: DirectionsCarIcon,
  EventRepeat: EventRepeatIcon,
  Feedback: FeedbackIcon,
  FolderOpen: FolderOpenIcon,
  Gavel: GavelIcon,
  Handshake: HandshakeIcon,
  Handyman: HandymanIcon,
  History: HistoryIcon,
  Inventory: InventoryIcon,
  Inventory2: Inventory2Icon,
  LocalGasStation: LocalGasStationIcon,
  LocalShipping: LocalShippingIcon,
  Map: MapIcon,
  Message: MessageIcon,
  MonetizationOn: MonetizationOnIcon,
  Notes: NotesIcon,
  Notifications: NotificationsIcon,
  People: PeopleIcon,
  Person: PersonIcon,
  Public: PublicIcon,
  Receipt: ReceiptIcon,
  ReceiptLong: ReceiptLongIcon,
  Route: RouteIcon,
  Rule: RuleIcon,
  Schedule: ScheduleIcon,
  Security: SecurityIcon,
  Settings: SettingsIcon,
  Shield: ShieldIcon,
  SpaceDashboard: SpaceDashboardIcon,
  Storage: StorageIcon,
  TaskAlt: TaskAltIcon,
  TimerOff: TimerOffIcon,
  WarningAmber: WarningAmberIcon,
  WhatsApp: WhatsAppIcon,
};

export { NAV_ICONS };
